<template lang="pug">
  WtRouterLink.dots-to-member-profile-settings(
    v-if="isLinkToProfile"
    to="MemberProfileSettings"
  )
    BIcon(slot="icon" icon="dots-horizontal")
  WtActionMenu(
    :mobileModal="false"
    v-else
  ).dots-to-member-profile-settings
    WtActionMenuItem.remove-friend.has-text-danger(
      icon="account-remove"
      text="Unfriend"
      @click.native="!isProcessing ? deleteFriend() : null"
    )
</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";
import WtActionMenuItem from "@@/WtActionMenuItem/WtActionMenuItem";
import { mapActions } from "vuex";

export default {
  name: "UserCardActionsMenu",

  components: {
    WtRouterLink,
    WtButton,
    WtActionMenu,
    WtActionMenuItem
  },

  props: {
    isLinkToProfile: {
      type: Boolean,
      default: false
    },
    friend: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      isProcessing: false,
      isProcessed: false,
      memberId: this.$auth.user().id,
      removeFriendsError: false
    };
  },

  methods: {
    ...mapActions("members", [
      "removeFriend",
      "setRemoveFriendProcessingForMember",
      "fetchFriends"
    ]),

    async deleteFriend() {
      this.$buefy.dialog.confirm({
        title: "Unfriend",
        confirmText: "Confirm",
        type: "is-danger",
        hasIcon: true,
        message: `Are you sure you want remove ${this.friend.username} as a friend?`,
        closeOnConfirm: false,
        onConfirm: async (_, dialog) => {
          dialog.confirmText = "Processing ...";
          dialog.$refs.confirmButton.disabled = true;

          const payload = {
            memberId: this.memberId,
            friendId: this.friend.id,
            friendUsername: this.friend.username
          };

          // commit processing-status to store
          // to display loading spinner
          // until data is fetched
          this.isProcessing = true;
          this.setRemoveFriendProcessingForMember(this.memberId);

          try {
            await this.removeFriend(payload);
            // refresh friends data
            this.fetchFriends({ memberId: this.memberId });
          } catch (error) {
            this.removeFriendsError = true;
          }

          this.setRemoveFriendProcessingForMember(false);
          this.isProcessing = false;
          this.isProcessed = true;
          dialog.close();
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.dots-to-member-profile-settings
  cursor: pointer
  position: absolute
  right: $box-padding
  top: $box-padding
</style>
